import ProfileContactsForm from '@/components/Forms/ProfileContactsForm';
import { useGetUserLocation } from '@/query/queries/user/useGetUserLocation';
import { useUpdateProfileContact } from '@/query/queries/user/useUpdateProfileContact';
import { uploadFile } from '@/store/services/commonServices';
import { useGetMe } from '@/hooks/shared/useGetMe';

const ProfileContactsModal = ({ onClose, onSuccess }) => {
  const { user } = useGetMe();
  const { data: userLocation } = useGetUserLocation();
  const { mutateAsync: updateProfileContact  } = useUpdateProfileContact();

  const onSubmit = async values => {
    const payload = {
      phone: values.phone,
      country: values.country,
      city: values.city,
      country_code: values.country_code,
      address: values.address,
      postal_code: values.postal_code,
      proof_of_residential_address: values.proof_of_residential_address[0]?.id || null,
    };

    if (values.proof_of_residential_address[0] && !values.proof_of_residential_address[0].id) {
      const result = await uploadFile(values.proof_of_residential_address[0]);
      if (result && result.success) {
        payload.proof_of_residential_address = result.data.id;
      }
    }
    const res = await updateProfileContact(payload);
    if (res?.id) {
      onSuccess && onSuccess(res);
      onClose();
    }
  };

  return (
    <ProfileContactsForm
      user={user}
      userLocation={userLocation}
      onSubmit={onSubmit}
      onCancel={onClose}
    />
  );
};

export default ProfileContactsModal;
